module.exports = {
      id: "ic-25-index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-25-index-usage",
      toString: function () {
        return this.url;
      }
    }